(function () {
  var root = document.getElementById("se-pro");
  if (!root) return;

  var loggedIn = root.getAttribute("data-in") === "yes";
  var toggle = document.getElementById("se-toggle");
  if (toggle) toggle.addEventListener("click", function () { root.classList.toggle("open"); });
  if (!loggedIn) return;

  var SE = {
    endpoint: "https://stitch-estimator-ai.sal-b4d.workers.dev",
    quoteEmail: "sal@tex-inc.com"
  };
  var LABEL = { lettering: "Lettering / Stock", leftchest: "Left Chest", jacketback: "Jacket Back", custom: "Custom Size" };
  var DIGI = "Custom Digitizing";
  var LOGO = "https://cdn.shopify.com/s/files/1/0976/7927/8378/files/Stitch_Estimator_Pro_2026-2.png?v=1780101756";
  var SITE_URL = "embroiderydesignclub.com";
  var STORE_KEY = "edc_se_state";

  var $ = function (id) { return document.getElementById(id); };
  var CUST = { name: root.getAttribute("data-cn") || "", email: root.getAttribute("data-ce") || "" };
  var type = "lettering", imgData = null, imgMime = null, lastFileUrl = null, lastInstructions = "";

  var types = $("se-types");
  if (types) types.addEventListener("click", function (e) {
    var t = e.target.closest(".se-type");
    if (!t) return;
    var all = types.querySelectorAll(".se-type");
    for (var i = 0; i < all.length; i++) all[i].classList.remove("on");
    t.classList.add("on");
    type = t.getAttribute("data-type");
  });
  function setActiveType(tp) {
    type = tp;
    if (!types) return;
    var all = types.querySelectorAll(".se-type");
    for (var i = 0; i < all.length; i++) {
      all[i].classList.toggle("on", all[i].getAttribute("data-type") === tp);
    }
  }

  var drop = $("se-drop");
  var DROP_PROMPT = '<span>Click to upload artwork<br>(PNG / JPG / PDF / SVG)</span><input type="file" id="se-file" accept="image/png,image/jpeg,application/pdf,.pdf,image/svg+xml,.svg" style="display:none;">';

  var _pdfjsReady = null;
  function loadPdfJs() {
    if (_pdfjsReady) return _pdfjsReady;
    _pdfjsReady = new Promise(function (resolve, reject) {
      if (window.pdfjsLib) return resolve(window.pdfjsLib);
      var s = document.createElement("script");
      s.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
      s.onload = function () {
        try { window.pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js"; } catch (e) {}
        resolve(window.pdfjsLib);
      };
      s.onerror = function () { reject(new Error("pdfjs load failed")); };
      document.head.appendChild(s);
    });
    return _pdfjsReady;
  }
  function pdfToImage(file) {
    return loadPdfJs().then(function (lib) {
      return file.arrayBuffer().then(function (buf) {
        return lib.getDocument({ data: new Uint8Array(buf) }).promise;
      }).then(function (pdf) {
        return pdf.getPage(1);
      }).then(function (page) {
        var vp = page.getViewport({ scale: 2 });
        var c = document.createElement("canvas");
        c.width = vp.width; c.height = vp.height;
        var ctx = c.getContext("2d");
        ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, c.width, c.height);
        return page.render({ canvasContext: ctx, viewport: vp }).promise.then(function () {
          return c.toDataURL("image/png");
        });
      });
    });
  }
  function svgToImage(file) {
    return new Promise(function (resolve, reject) {
      var fr = new FileReader();
      fr.onload = function (ev) {
        var txt = ev.target.result;
        var W = 1000, H = 1000;
        try {
          var docp = new DOMParser().parseFromString(txt, "image/svg+xml");
          var svg = docp.documentElement;
          var wAttr = parseFloat(svg.getAttribute("width"));
          var hAttr = parseFloat(svg.getAttribute("height"));
          var vw = 0, vh = 0, vb = svg.getAttribute("viewBox");
          if (vb) { var p = vb.split(/[\s,]+/); vw = parseFloat(p[2]); vh = parseFloat(p[3]); }
          if (!(wAttr > 0) || !(hAttr > 0)) {
            if (vw > 0 && vh > 0) { wAttr = vw; hAttr = vh; } else { wAttr = 1000; hAttr = 1000; }
            svg.setAttribute("width", wAttr);
            svg.setAttribute("height", hAttr);
            txt = new XMLSerializer().serializeToString(svg);
          }
          var scale = 1200 / Math.max(wAttr, hAttr);
          if (scale > 4) scale = 4;
          if (scale < 1) scale = 1;
          W = Math.round(wAttr * scale);
          H = Math.round(hAttr * scale);
        } catch (e) {}
        var url = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(txt);
        var img = new Image();
        img.onload = function () {
          try {
            var c = document.createElement("canvas");
            c.width = W; c.height = H;
            var ctx = c.getContext("2d");
            ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, W, H);
            ctx.drawImage(img, 0, 0, W, H);
            resolve(c.toDataURL("image/png"));
          } catch (e) { reject(e); }
        };
        img.onerror = function () { reject(new Error("svg load failed")); };
        img.src = url;
      };
      fr.onerror = function () { reject(new Error("svg read failed")); };
      fr.readAsText(file);
    });
  }

  function bindFile() {
    var fileInput = $("se-file");
    if (fileInput) fileInput.addEventListener("change", function (e) {
      var f = e.target.files[0];
      if (!f) return;
      if ($("se-img-err")) $("se-img-err").style.display = "none";
      var isPdf = (f.type === "application/pdf") || /\.pdf$/i.test(f.name);
      if (isPdf) {
        showPreview("", "Reading PDF...");
        pdfToImage(f).then(function (durl) {
          imgData = durl; imgMime = "image/png";
          showPreview(durl, f.name + " (page 1)");
        }).catch(function () {
          if (drop) drop.innerHTML = '<span style="color:#c0392b;">Could not read that PDF. Please upload a PNG or JPG.</span>' + DROP_PROMPT;
          bindFile();
        });
        return;
      }
      var isSvg = (f.type === "image/svg+xml") || /\.svg$/i.test(f.name);
      if (isSvg) {
        showPreview("", "Reading SVG...");
        svgToImage(f).then(function (durl) {
          imgData = durl; imgMime = "image/png";
          showPreview(durl, f.name + " (vector)");
        }).catch(function () {
          if (drop) drop.innerHTML = '<span style="color:#c0392b;">Could not read that SVG. Please upload a PNG or JPG.</span>' + DROP_PROMPT;
          bindFile();
        });
        return;
      }
      imgMime = f.type;
      var r = new FileReader();
      r.onload = function (ev) {
        imgData = ev.target.result;
        showPreview(imgData, f.name);
      };
      r.readAsDataURL(f);
    });
  }
  function showPreview(src, label) {
    if (drop) drop.innerHTML = '<img src="' + src + '" alt="design"><div style="margin-top:3px;font-size:10px;">' + (label || "design") + '</div>';
  }
  if (drop) {
    drop.addEventListener("click", function () {
      var f = $("se-file");
      if (f) f.click();
    });
    bindFile();
  }
  (function () {
    var fi = $("se-file");
    if (fi) fi.setAttribute("accept", "image/png,image/jpeg,application/pdf,.pdf,image/svg+xml,.svg");
    if (drop) { var sp = drop.querySelector("span"); if (sp && /upload artwork/i.test(sp.textContent || "")) sp.innerHTML = "Click to upload artwork<br>(PNG / JPG / PDF / SVG)"; }
  })();

  function round100(n) { return Math.round(n / 100) * 100; }
  function commas(n) { return n.toLocaleString("en-US"); }
  function money(n) { return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function colorWord(c) { return c + (c === 1 ? " color" : " colors"); }
  /* Digitizing price by STITCH COUNT (hats / LC). Updates live with the fill slider. */
  function priceForStitches(n) {
    if (n <= 6000) return 25;
    if (n <= 15000) return 35;
    if (n <= 25000) return 45;
    if (n <= 35000) return 55;
    return null;
  }
  function priceText(n) { var p = priceForStitches(n); return p == null ? "Request a quote (35k+)" : money(p); }
  function colorFactor(c) { return 1; }
  function row(a, b) {
    return '<div style="display:flex;justify-content:space-between;padding:9px 0;border-bottom:1px solid #e6ebf2;font-size:15px;"><span>' + a + '</span><b style="color:#004288;">' + b + "</b></div>";
  }

  function computeFingerprint(dataUrl) {
    return new Promise(function (resolve) {
      try {
        var img = new Image();
        img.onload = function () {
          function grid(n) {
            var c = document.createElement("canvas"); c.width = n; c.height = n;
            var ctx = c.getContext("2d");
            ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, n, n);
            ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = "high";
            ctx.drawImage(img, 0, 0, n, n);
            return ctx.getImageData(0, 0, n, n).data;
          }
          var g = grid(16), c8 = grid(8), vec = [], i, s = 0;
          for (i = 0; i < 256; i++) {
            vec.push((0.299 * g[i * 4] + 0.587 * g[i * 4 + 1] + 0.114 * g[i * 4 + 2]) / 255);
          }
          for (i = 0; i < 64; i++) {
            vec.push(c8[i * 4] / 255); vec.push(c8[i * 4 + 1] / 255); vec.push(c8[i * 4 + 2] / 255);
          }
          for (i = 0; i < vec.length; i++) s += vec[i] * vec[i];
          s = Math.sqrt(s) || 1;
          for (i = 0; i < vec.length; i++) vec[i] = vec[i] / s;
          resolve(vec);
        };
        img.onerror = function () { resolve(null); };
        img.src = dataUrl;
      } catch (e) { resolve(null); }
    });
  }

  function seFetch(payload, tries) {
    tries = tries || 3;
    return new Promise(function (resolve, reject) {
      function attempt(n) {
        var done = false;
        var ctl = (typeof AbortController !== "undefined") ? new AbortController() : null;
        var to = setTimeout(function () { if (ctl) ctl.abort(); }, 45000);
        var opts = { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) };
        if (ctl) opts.signal = ctl.signal;
        fetch(SE.endpoint, opts)
          .then(function (res) { clearTimeout(to); if (!res.ok) throw 0; return res.json(); })
          .then(function (d) { done = true; resolve(d); })
          .catch(function (err) {
            clearTimeout(to);
            if (done) return;
            if (n < tries) { setTimeout(function () { attempt(n + 1); }, 1200 * n); }
            else { reject(err); }
          });
      }
      attempt(1);
    });
  }

  function saveState(d) {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify({
        name: d.name, w: d.w, h: d.h, type: type, colors: d.colors,
        baseRaw: d.baseRaw, spi: d.spi, fill: d.fill, notes: d.notes,
        img: d.img || null, imgMime: imgMime || null
      }));
    } catch (e) {}
  }
  function clearState() { try { localStorage.removeItem(STORE_KEY); } catch (e) {} }
  function loadState() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || "null"); } catch (e) { return null; } }

  function resetAll() {
    clearState();
    imgData = null; imgMime = null;
    if ($("se-name")) $("se-name").value = "";
    if ($("se-w")) $("se-w").value = "";
    if ($("se-h")) $("se-h").value = "";
    if ($("se-colors")) $("se-colors").value = "";
    if ($("se-notes")) $("se-notes").value = "";
    setActiveType("lettering");
    if (drop) { drop.innerHTML = DROP_PROMPT; bindFile(); }
    if ($("se-result")) $("se-result").innerHTML = "";
    if ($("se-name")) $("se-name").focus();
  }

  var __edcHR = document.querySelector(".se-hdreset");
  if (__edcHR) {
    __edcHR.onclick = function () {
      try { localStorage.removeItem(STORE_KEY); } catch (e) {}
      resetAll();
      return false;
    };
  }

  var _jspdfReady = null;
  function loadJsPDF() {
    if (_jspdfReady) return _jspdfReady;
    _jspdfReady = new Promise(function (resolve, reject) {
      if (window.jspdf && window.jspdf.jsPDF) return resolve(window.jspdf.jsPDF);
      var s = document.createElement("script");
      s.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
      s.onload = function () {
        if (window.jspdf && window.jspdf.jsPDF) resolve(window.jspdf.jsPDF);
        else reject(new Error("jspdf missing"));
      };
      s.onerror = function () { reject(new Error("jspdf load failed")); };
      document.head.appendChild(s);
    });
    return _jspdfReady;
  }
  function prepImage(src, conv) {
    return new Promise(function (resolve) {
      if (!src) return resolve(null);
      var im = new Image();
      if (conv) im.crossOrigin = "anonymous";
      im.onload = function () {
        var out = { w: im.naturalWidth || im.width, h: im.naturalHeight || im.height, url: src };
        if (conv) {
          try {
            var c = document.createElement("canvas");
            c.width = out.w; c.height = out.h;
            c.getContext("2d").drawImage(im, 0, 0);
            out.url = c.toDataURL("image/png");
          } catch (e) { return resolve(null); }
        }
        resolve(out);
      };
      im.onerror = function () { resolve(null); };
      im.src = src;
    });
  }
  function safeName(s) {
    return String(s || "design").replace(/[^a-z0-9]+/ig, "-").replace(/^-+|-+$/g, "") || "design";
  }
  function doPrint(d) {
    var btn = $("se-print");
    var prev = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = "Building file..."; }
    function restore() { if (btn) { btn.disabled = false; btn.textContent = prev || "Download Estimate"; } }
    loadJsPDF().then(function (JsPDF) {
      return Promise.all([prepImage(d.img, false), prepImage(LOGO, true)]).then(function (arr) {
        var design = arr[0], logo = arr[1];
        var doc = new JsPDF({ unit: "pt", format: "letter" });
        var PW = doc.internal.pageSize.getWidth();
        var M = 48, y = 54;
        if (logo) {
          var lw = 150, lh = lw * (logo.h / logo.w);
          if (lh > 64) { lh = 64; lw = lh * (logo.w / logo.h); }
          try { doc.addImage(logo.url, "PNG", (PW - lw) / 2, y, lw, lh); } catch (e) {}
          y += lh + 14;
        } else { y += 6; }
        doc.setDrawColor(0, 66, 136); doc.setLineWidth(2); doc.line(M, y, PW - M, y); y += 26;
        doc.setFontSize(12);
        function pr(label, val) {
          doc.setFont("helvetica", "normal"); doc.setTextColor(120, 120, 120); doc.text(label, M, y);
          doc.setFont("helvetica", "bold"); doc.setTextColor(0, 66, 136); doc.text(String(val), PW - M, y, { align: "right" });
          y += 22;
        }
        pr("Estimate name", d.name);
        pr("Design type", DIGI);
        pr("Size", d.w + " x " + d.h + " in");
        pr("Colors", colorWord(d.colors));
        pr("Fill / density", d.fill + "%");
        y += 6;
        if (design) {
          var maxW = 240, maxH = 180;
          var r = Math.min(maxW / design.w, maxH / design.h);
          if (!(r > 0) || !isFinite(r)) r = 1;
          var iw = design.w * r, ih = design.h * r;
          var dfmt = /^data:image\/jpe?g/i.test(design.url) ? "JPEG" : "PNG";
          try { doc.addImage(design.url, dfmt, (PW - iw) / 2, y, iw, ih); } catch (e) {}
          y += ih + 16;
        }
        doc.setFillColor(240, 246, 255); doc.setDrawColor(214, 230, 251);
        doc.roundedRect(M, y, PW - 2 * M, 64, 8, 8, "FD");
        doc.setTextColor(0, 66, 136); doc.setFont("helvetica", "bold"); doc.setFontSize(30);
        doc.text(commas(d.stitches), PW / 2, y + 36, { align: "center" });
        doc.setFontSize(9); doc.setTextColor(122, 135, 148); doc.setFont("helvetica", "normal");
        doc.text("ESTIMATED STITCHES", PW / 2, y + 52, { align: "center" });
        y += 64 + 16;
        doc.setFillColor(255, 248, 243); doc.setDrawColor(255, 217, 194);
        doc.roundedRect(M, y, PW - 2 * M, 40, 8, 8, "FD");
        doc.setTextColor(38, 48, 60); doc.setFont("helvetica", "bold"); doc.setFontSize(13);
        doc.text(DIGI, M + 14, y + 25);
        doc.setTextColor(242, 107, 33); doc.setFontSize(15);
        doc.text(priceText(d.stitches), PW - M - 14, y + 25, { align: "right" });
        y += 40 + 24;
        doc.setDrawColor(204, 204, 204); doc.setLineWidth(1);
        if (doc.setLineDashPattern) doc.setLineDashPattern([3, 3], 0);
        doc.line(M, y, PW - M, y);
        if (doc.setLineDashPattern) doc.setLineDashPattern([], 0);
        y += 18;
        doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.setTextColor(85, 85, 85);
        doc.text("Prepared for: " + CUST.name + " (" + CUST.email + ")", M, y); y += 14;
        doc.text("Embroidery Design Club - Stitch Estimator Pro", M, y); y += 14;
        doc.setTextColor(0, 66, 136); doc.setFont("helvetica", "bold"); doc.text(SITE_URL, M, y);
        doc.save("Stitch-Estimate-" + safeName(d.name) + ".pdf");
        restore();
      });
    }).catch(function () {
      restore();
      alert("Sorry - the estimate file could not be generated. Please try again in a moment.");
    });
  }

  function render(opts, skipSave) {
    var baseRaw = opts.baseRaw, spi = opts.spi, notes = opts.notes,
        w = opts.w, h = opts.h, name = opts.name, colors = opts.colors;
    var fill = opts.fill || 100;
    var cf = colorFactor(colors);
    function calc(f) { return Math.max(100, round100(baseRaw * cf * (f / 100))); }

    var note = notes ? '<div class="se-ainote"><b>Digitizing Agent Analysis:</b> ' + notes + "</div>" : "";
    $("se-result").innerHTML =
      '<div class="se-est"><div class="se-est-top"><h4>' + name + '</h4><span>' + DIGI + '</span></div>'
      + '<div class="se-est-body">'
      + '<div class="se-big"><div class="n" id="se-num">' + commas(calc(fill)) + '</div><div class="l">Estimated Stitches</div></div>'
      + '<div class="se-line"><span>Size</span><span>' + w + "in x " + h + "in</span></div>"
      + '<div class="se-line"><span>Colors</span><span>' + colorWord(colors) + "</span></div>"
      + '<div style="margin:8px 0 4px;"><div style="display:flex;justify-content:space-between;font-size:11.5px;color:#26303c;"><span>Fill / density (drag to adjust)</span><b id="se-fillval" style="color:#004288;">' + fill + '%</b></div>'
      + '<input type="range" id="se-fill" min="10" max="150" step="5" value="' + fill + '" style="width:100%;margin-top:3px;accent-color:#f26b21;"><div style="display:flex;justify-content:space-between;font-size:8.5px;color:#9aa7b4;margin-top:1px;"><span>lighter</span><span>100% = as shown</span><span>denser</span></div></div>'
      + note
      + '<button class="se-cost-btn" id="se-cost-btn">Convert to Digitizing Cost</button><div id="se-cost"></div>'
      + '<div class="se-acts"><button id="se-print">Download Estimate</button><button id="se-reset">Reset</button></div>'
      + '</div></div>';

    var data = { stitches: calc(fill), spi: spi, baseRaw: baseRaw, notes: notes, w: w, h: h, name: name, colors: colors, fill: fill, img: imgData };
    if (!skipSave) saveState(data);

    var slider = $("se-fill");
    if (slider) slider.addEventListener("input", function () {
      var f = parseInt(this.value, 10);
      data.fill = f;
      data.stitches = calc(f);
      $("se-fillval").textContent = f + "%";
      $("se-num").textContent = commas(data.stitches);
      var pv = $("se-price-val");
      if (pv) pv.textContent = priceText(data.stitches);
      saveState(data);
    });

    $("se-print").addEventListener("click", function () { doPrint(data); });
    $("se-reset").addEventListener("click", resetAll);

    $("se-cost-btn").addEventListener("click", function () {
      var box = '<div class="se-line"><span>' + DIGI + '</span><span>by stitch count</span></div>'
        + '<div class="se-cost-total"><span>Digitizing Price</span><span id="se-price-val" style="white-space:nowrap;">' + priceText(data.stitches) + "</span></div>";
      $("se-cost").innerHTML = '<div class="se-costbox">' + box + '</div><button class="se-order" id="se-order">Order Digitizing</button>';
      this.style.display = "none";

      $("se-order").addEventListener("click", function () {
        var btn = this;
        btn.disabled = true;
        btn.textContent = "Sending order...";
        seFetch({
          action: "order", image: imgData, name: name, designType: DIGI,
          width: w, height: h, colorCount: colors, fill: data.fill,
          stitches: data.stitches, spi: spi, price: priceText(data.stitches),
          notes: notes, custName: CUST.name, custEmail: CUST.email, fileUrl: lastFileUrl, instructions: lastInstructions
        }).then(function () {
          btn.textContent = "Design Order Sent!";
          btn.style.background = "#0c7a45";
          btn.disabled = true;
          if (!$("se-reset-after")) {
            var rb = document.createElement("button");
            rb.id = "se-reset-after";
            rb.className = "se-order";
            rb.style.background = "#004288";
            rb.style.marginTop = "8px";
            rb.textContent = "Start New Estimate";
            rb.addEventListener("click", resetAll);
            btn.parentNode.appendChild(rb);
          }
        }).catch(function () {
          var b = "Digitizing order request%0D%0ACustomer: " + encodeURIComponent(CUST.name) + " (" + encodeURIComponent(CUST.email) + ")%0D%0AEstimate: " + encodeURIComponent(name) + "%0D%0AType: " + encodeURIComponent(DIGI) + "%0D%0ASize: " + w + " x " + h + " in%0D%0AColors: " + colors + "%0D%0AFill: " + data.fill + "%25%0D%0AStitches: " + commas(data.stitches) + "%0D%0APrice: " + encodeURIComponent(priceText(data.stitches)) + "%0D%0A%0D%0APlease attach your design file. Thank you.";
          window.location.href = "mailto:" + SE.quoteEmail + "?subject=" + encodeURIComponent("Digitizing Order from EDC - " + name) + "&body=" + b;
          btn.disabled = false;
          btn.textContent = "Order Digitizing";
        });
      });
    });
  }

  var go = $("se-go");
  if (go) go.addEventListener("click", function () {
    var name = $("se-name").value.trim();
    var w = parseFloat($("se-w").value);
    var h = parseFloat($("se-h").value);
    var colors = parseInt($("se-colors") ? $("se-colors").value : "", 10);
    if ($("se-name-err")) $("se-name-err").style.display = name ? "none" : "block";
    if ($("se-img-err")) $("se-img-err").style.display = imgData ? "none" : "block";
    if ($("se-colors-err")) $("se-colors-err").style.display = (colors > 0) ? "none" : "block";
    if (!name) { $("se-name").focus(); return; }
    if (!imgData) return;
    if (!(w > 0) || !(h > 0)) { alert("Enter a width and height."); return; }
    if (!(colors > 0)) { if ($("se-colors")) $("se-colors").focus(); return; }

    lastInstructions = $("se-notes") ? $("se-notes").value.trim() : "";
    go.disabled = true;
    go.textContent = "Analyzing artwork...";
    computeFingerprint(imgData)
      .then(function (fp) {
        return seFetch({ image: imgData, mediaType: imgMime, width: w, height: h, colorCount: colors, fingerprint: fp, custName: CUST.name, custEmail: CUST.email, instructions: lastInstructions });
      })
      .then(function (d) {
        var spi = parseInt(d.stitchesPerSqIn, 10);
        if (!spi) throw 0;
        lastFileUrl = d.fileUrl || null;
        render({ baseRaw: w * h * spi, spi: spi, notes: d.notes || "", w: w, h: h, name: name, colors: colors, fill: 100 });
      })
      .catch(function () {
        $("se-result").innerHTML = '<div class="se-msg">Could not reach the estimator. Please wait a moment and try again.</div>';
      })
      .then(function () { go.disabled = false; go.textContent = "Estimate Stitches"; });
  });

  (function restore() {
    var s = loadState();
    if (!s || !s.baseRaw) return;
    if (s.img) { imgData = s.img; imgMime = s.imgMime || null; showPreview(s.img, "saved design"); }
    if (s.name && $("se-name")) $("se-name").value = s.name;
    if (s.w && $("se-w")) $("se-w").value = s.w;
    if (s.h && $("se-h")) $("se-h").value = s.h;
    if (s.colors && $("se-colors")) $("se-colors").value = s.colors;
    if (s.type) setActiveType(s.type);
    render({ baseRaw: s.baseRaw, spi: s.spi, notes: s.notes || "", w: s.w, h: s.h, name: s.name, colors: s.colors || 1, fill: s.fill || 100 }, true);
  })();
})();
